module.exports = {
	"articleTitle1": "Man arrested on Diag after fleeing from police ",
	"catImage": "orangestar.png",
	"totalCats": 3,
	"name": "The Diag",
	"articleLink2": "https://www.michigandaily.com/section/news/police-called-diag-over-chalk-messages-targeting-islam",
	"articleSnippet1": "Mar 16, 2017 ... A crowd of students quickly gathered on the Diag after an Ann Arbor Police \nDepartment vehicle knocked over a lamppost while pursuing a ...",
	"articleSnippet2": "Mar 30, 2016 ... Though the phrases were written in chalk, students gathered on the Diag \nWednesday afternoon said they thought the effects of them were more ...",
	"totalMisc": 1,
	"articleTitle2": "Schlissel responds to anti-Islam Diag chalk ",
	"address": "No Address",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161104/cmm.FEA_.freeHighFives.11.2.16.104.jpg?itok=LkrkXMSy",
			"caption": "Engineering senior Ted Xiao offers free high fives as a part of the Random Acts of Kindness club on the Diag on Wednesday.",
			"author": "Claire Meingast"
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161027/msk.NEW_.HomecomingPepRally.10.21.16.0209%20copy.jpg?itok=BLd8VX6J",
			"caption": "Percussion group Groove performs at the Michigan Homecoming Pep Rally on the Diag Friday.",
			"author": "Max Kuang"
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160329/gbh.NEWS_.LahoreVigil.3.28.16.007_0.jpg?itok=iR1DoOyU",
			"caption": "LSA junior Eman Hijab, president of Michigan Pakistanis, takes a moment of silence, along with other members at Michigan Pakistanis, at a vigil for the Lahore, Pakistan bombing victims in the Diag on Monday.",
			"author": "Grant Hardy"
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161117/adr.NEW_.LoveMovement.11.17.16.059.jpg?itok=ozFO8hMP",
			"caption": "Business junior Christopher McClendon sings as part of the Love Movement on the Diag Thursday.",
			"author": "Alexis Rankin"
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160325/DAS_1962%5B1%5D.jpg?itok=sJfdEh46",
			"caption": "LSA sophomore Madeline McCabe speaks to passerbys to raise awareness for the Red Cross International Humanitarian Law Action Campaign on the Diag on Thursday.",
			"author": "Ryan McLoughlin"
		}
	],
	"position": {
		"lat": 42.277019,
		"lng": -83.738233
	},
	"tips": [
		{
			"text": "There is almost always something going on in the Diag. It's gotta be the most lively spot on campus.",
			"person": "Erik Forkin"
		},
		{
			"text": "This and the arb are the best places on campus for hammocking.",
			"person": "Erik Forkin"
		}
	],
	"articleLink1": "https://www.michigandaily.com/section/crime/man-arrested-diag-after-fleeing-police",
	"categories": {
		"yogaspot": 1,
		"sunbathingspot": 1,
		"recarea": 1,
		"studyspot": 1,
		"pickupsports": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/diag.json
// module id = 862
// module chunks = 0